import { Country, State, City } from ".";
import { IAuthResponse } from "../redux/features/auth/IAuthState";

//DeleteShipFromPort
export interface DeleteShipFromPort extends IAuthResponse {
    id: string;
}

export type ShipFromPortRequestPayload = {
    id: string;
    contactName: string;
    status: number;
    port: string;
    country: string;
    state: string;
    address1: string;
    address2: string;
    city: string;
    zip: string;
    phone: string;
    email: string;
    comment: string;
    deletedAt: string | null;
    createdAt: string;
    updatedAt: string;
};

export const OtherShipPort = "other";